/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NicknameUniquenessResponse { 
    nickname?: string;
    unique?: boolean;
    message?: string;
    gea_puid?: string;
    variable_id?: string;
    conflicting_variable_id?: string;
}

